module.exports = __webpack_public_path__ + "images/stickers/heart@2x.51a19b35bc5092e9e276.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/heart@2x.png
// module id = Ws/7
// module chunks = 1